import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconChartSmooth = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.3601 5.49363C18.1112 5.05934 17.5811 4.87714 17.1239 5.0874L13.5576 6.72737L14.3515 8.56909L15.6201 7.98572C14.5892 10.7747 13.2644 12.6858 11.5975 14.0522C9.83938 15.4934 7.62319 16.3926 4.77709 17.005C4.24942 17.1185 3.91078 17.6524 4.02071 18.1974C4.13064 18.7424 4.64752 19.0922 5.17519 18.9786C8.18476 18.331 10.7263 17.3402 12.8109 15.6313C14.8547 13.956 16.3856 11.6516 17.5219 8.48996L18.2171 10.1017L20.0002 9.2817L18.4124 5.59826L18.3601 5.49363Z"
        />
      </svg>
    );
  }
);
